import { createSlice } from "@reduxjs/toolkit"

export const gatewaySlice = createSlice({
  name: "gateway",

  initialState: {
    entry: null
  },

  reducers: {
    updateGateway: (state, action) => {
      state.entry = action.payload
    },

    resetGateway: state => {
      state.entry = null
    }
  }
})

export const { updateGateway, resetGateway } = gatewaySlice.actions
export const gateway = state => state.gateway.entry
